import { UpdateProposalRequestDto } from '@modules/proposals/api/dto/updateProposal.dto';
import { legacyTypes } from '@modules/proposals/api/mappers/legacyTypes';
import { ProposalCreationClientAndMortgageForm } from '../types';

const getPropertyLocation = ({ propertyLocation, isDIFC }: { propertyLocation?: string, isDIFC?: string }) => {
  if (isDIFC === 'true') {
    return 'DIFC';
  }

  if (!propertyLocation?.trim()) {
    return null;
  }

  return propertyLocation;
};

export const mapPropertyDetailsFormToRequest = (
  data: ProposalCreationClientAndMortgageForm
): UpdateProposalRequestDto['property'] => ({
  property_emirate: data.property_details.state,
  property_location: getPropertyLocation({
    propertyLocation: data.property_details.property_location,
    isDIFC: data.property_details.is_difc,
  })!,
  property_status: data.property_details.property_status
    ? legacyTypes.propertyStatus[data.property_details.property_status] : undefined,
  property_value: Number.parseInt(data.mortgage_details.property_value, 10),
});
